import React from 'react';
import { Form, Button } from 'react-bootstrap';
import { Plus, Trash2 } from 'lucide-react';
import { parseOfficialStoreUrls, serializeOfficialStoreUrls } from '../../../../utils/sourcingLinks';

interface OfficialStoreUrlsEditorProps {
  officialStoreUrlsJson?: string | undefined;
  onOfficialStoreUrlsChange: (serializedOfficialStoreUrls: string) => void;
}

// Bookkeeping only: official store links (Naver brand store, Olive Young, brand sites) shown in the OMS; not scraped.
export const OfficialStoreUrlsEditor: React.FC<OfficialStoreUrlsEditorProps> = ({ officialStoreUrlsJson, onOfficialStoreUrlsChange }) => {
  const officialStoreUrls = parseOfficialStoreUrls(officialStoreUrlsJson);

  const emitOfficialStoreUrls = (updatedOfficialStoreUrls: string[]) => {
    onOfficialStoreUrlsChange(serializeOfficialStoreUrls(updatedOfficialStoreUrls));
  };

  const addOfficialStoreUrl = () => {
    emitOfficialStoreUrls([...officialStoreUrls, '']);
  };

  const updateOfficialStoreUrl = (urlIndex: number, url: string) => {
    emitOfficialStoreUrls(officialStoreUrls.map((existingUrl, currentIndex) => (currentIndex === urlIndex ? url : existingUrl)));
  };

  const removeOfficialStoreUrl = (urlIndex: number) => {
    emitOfficialStoreUrls(officialStoreUrls.filter((_, currentIndex) => currentIndex !== urlIndex));
  };

  return (
    <div className="col-md-12">
      <Form.Label style={{ fontSize: '0.75rem', fontWeight: '600', display: 'block', marginBottom: '0.5rem', marginTop: '0.75rem' }}>
        Official Store URLs
      </Form.Label>

      {officialStoreUrls.map((officialStoreUrl, urlIndex) => (
        <div key={urlIndex} className="d-flex gap-2 mb-2 align-items-center">
          <Form.Control
            size="sm"
            type="url"
            placeholder="https://..."
            value={officialStoreUrl}
            onChange={(event) => updateOfficialStoreUrl(urlIndex, event.target.value)}
          />
          <Button size="sm" variant="outline-danger" onClick={() => removeOfficialStoreUrl(urlIndex)} title="Remove url">
            <Trash2 size={14} />
          </Button>
        </div>
      ))}

      <Button size="sm" variant="outline-secondary" onClick={addOfficialStoreUrl}>
        <Plus size={14} /> Add official store URL
      </Button>
    </div>
  );
};
